// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class RelationshipVm {
    @AutoMap() prId: string = null;
    @AutoMap() prName: string = null;
}
